import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipeModule } from './pipes/pipe.module';
import { DirectivesModule } from './directives/directive.module';

@NgModule({
  imports: [CommonModule, PipeModule, DirectivesModule],
  exports: [PipeModule, DirectivesModule],
  providers: [],
})
export class CoreModule {}
